import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import { useIsBulkExecution, useServiceOrder } from '../_load/ServiceOrderLoader'
import Accordion from '../../../../components/structure/accordion/Accordion'
import AccordionContent from '../../../../components/structure/accordion/AccordionContent'
import AccordionHeader from '../../../../components/structure/accordion/AccordionHeader'
import CheckInOutDetailsPanel from '../../_shared/panels/CheckInOutDetailsPanel'
import DocumentsDetailsPanel from '../../_shared/panels/DocumentsDetailsPanel'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import PlaceDetailsPanel from '../../_shared/place/PlaceDetailsPanel'
import Separator from '../../../../components/helpers/Separator'
import ServiceOrderDetailsPanel from '../../_shared/panels/ServiceOrderDetailsPanel'
import ServiceOrderObservationsPanel from '../../_shared/panels/ServiceOrderObservationsPanel'
import SchedulingPanel from '../../_shared/panels/ServiceOrderSchedulingPanel'
import CustomFieldsPanel from '../../_shared/panels/CustomFieldsPanel'

const GeneralAccordion = () => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()
  const isBulk = useIsBulkExecution()
  const place = prop('place', serviceOrder)
  const documents = prop('documents', serviceOrder)

  // Em modo de execução em massa, local/usuário/agendamento/check-in-out são
  // diferentes em cada atividade selecionada, então esse painel (que descreve
  // uma única atividade) não é exibido — apenas o questionário é comum.
  if (isBulk) return null

  return (
    <>
      <Accordion sticky lineBorder>
        <AccordionHeader>
          <Title size="h4" noMargin>
            {t('execution.accordion.general')}
          </Title>
        </AccordionHeader>
        <AccordionContent>
          <FlexGrid direction="column" align="stretch" gutter={0.5}>
            <ServiceOrderDetailsPanel serviceOrder={serviceOrder} hideIndicators />
            <PlaceDetailsPanel place={place} />
            <SchedulingPanel serviceOrder={serviceOrder} />
            <ServiceOrderObservationsPanel serviceOrder={serviceOrder} />
            <CustomFieldsPanel serviceOrder={serviceOrder} />
            <DocumentsDetailsPanel documents={documents} />

            <FlexCol>
              <FlexGrid gutter={0.5} wrap>
                <CheckInOutDetailsPanel type="checkIn" serviceOrder={serviceOrder} />
                <CheckInOutDetailsPanel type="checkOut" serviceOrder={serviceOrder} />
              </FlexGrid>
            </FlexCol>
          </FlexGrid>
        </AccordionContent>
      </Accordion>

      <Separator weight={4} />
    </>
  )
}

export default GeneralAccordion
